
<script>
import Nav from '../components/pc/nav.vue'
import Banner from '../components/pc/banner.vue'
import OK from '../components/pc/home/OK.vue'
import EM from '../components/pc/home/EM.vue'
import Savings from '../components/pc/home/savings.vue'
import Notices from '../components/pc/home/notices.vue'
import Contact from '../components/pc/home/contact.vue'
import Float from '../components/pc/home/float.vue'
import Bottom from '../components/pc/bottom.vue'
export default {
  data() {
    return {
      bannerFixed: false,
      selectorList: {
        0: 'banner',
        1: 'ok',
        2: 'em',
        3: 'savings',
        4: 'notices',
        5: 'contact'
      },
      carouselVisible: false,
      observer: null
    }
  },
  components: {
    Nav,
    Banner,
    OK,
    EM,
    Savings,
    Bottom,
    Notices,
    Contact,
    Float
  },
  mounted() {
    this.handleScroll()
    window.addEventListener('scroll', this.handleScroll)
    const ind = window.sessionStorage.getItem('toScrollInd')
    if (ind) this.goAnchor(ind)
    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.carouselVisible = true;
        this.observer.unobserve(this.$refs.carouselTrigger);
      }
    });
    this.observer.observe(this.$refs.carouselTrigger);
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 80) {
        this.bannerFixed = true
      } else {
        this.bannerFixed = false
      }
    },
    //获取当前元素的offsetTop
    getOffsetTop(obj) {
      let offsetTop = 0
      while (obj != window.document.body && obj != null) {
        offsetTop += obj.offsetTop
        obj = obj.offsetParent
      }
      return offsetTop
    },
    goAnchor(selector) {
      const activeName = this.selectorList[selector]
      const Id = document.getElementById(activeName)
      let offsetTop = this.getOffsetTop(Id)
      let scrollTop = offsetTop - 60
      window.scrollTo({
        top: scrollTop,
        behavior: 'smooth'
      })
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);

      if (this.observer) {
        this.observer.unobserve(this.$refs.carouselTrigger);
      }
    },
  },
}
</script>
<template>
  <div class="m-home">
    <Nav :isFixed="bannerFixed" @toScroll="goAnchor"></Nav>
    <Banner id="banner"></Banner>
    <OK id="ok" />
    <EM id="em" />
    <div class="hide-div" id="savings" ref="carouselTrigger">if savings</div>
    <Savings v-if="carouselVisible"/>
    <Notices id="notices" />
    <Contact id="contact" />
    <Float/>
    <Bottom></Bottom>
  </div>
</template>
<style lang="scss">
.hide-div{
  visibility: hidden;
  height: 1px;
}
</style>
